export default __webpack_public_path__ + "static/media/ICO-cart.86fcd2f8.svg";